import './App.css';
import { Box, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';
import Header from './components/Header';
import SideMenu from './components/SideMenu';
import AppNavbar from './components/AppNavbar';
import MainViewAdmin from './routes/MainViewAdmin';
import Providers from './context/Providers';
import useAuthenticatedBootstrap from './hook/useAuthenticatedBootstrap';

function Dashboard() {

  useAuthenticatedBootstrap();


  return (
    <Box sx={{ display: 'flex' }}>
    
        <Providers>
        
        <SideMenu/>
        <AppNavbar />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header />
            <MainViewAdmin />
          </Stack>
        </Box>
            </Providers>
        
    </Box>
  );
}

export default Dashboard;
